module.exports = "/assets/716b8e7735419434ac0d8bc1f77a8d77.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/S2.png
// module id = 1806
// module chunks = 0